import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { TrustStrip } from "../components/TrustStrip";
import { Services } from "../components/Services";
import { Proof } from "../components/Proof";
import { About } from "../components/About";
import { Technique } from "../components/Technique";
import { Euphoria } from "../components/Euphoria";
import { Testimonials } from "../components/Testimonials";
import { Process } from "../components/Process";
import { Banner } from "../components/Banner";
import { QuoteSection } from "../components/QuoteSection";
import { Retreat } from "../components/Retreat";
import { Foundation } from "../components/Foundation";
import { StickyBook } from "../components/StickyBook";
import { Footer } from "../components/Footer";

const Home = () => (
  <div className="min-h-screen bg-ink text-ivory">
    <a href="#quote" className="sr-only">Skip to quote form</a>
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <TrustStrip />
      <Services />
      <Proof />
      <About />
      <Technique />
      <Euphoria />
      <Testimonials />
      <Process />
      <Banner />
      <QuoteSection />
      <Retreat />
      <Foundation />
    </main>
    <StickyBook />
    <Footer />
  </div>
);

export default Home;
